export const ACCEPTED_VEHICLE_PANEL = "accepted-vehicle-panel";
export const VEHICLE_HISTORY_PANEL = "vehicle-history-panel";
export const VEHICLE_INCIDENTS_PANEL = "vehicle-incidents-panel";
export const VEHICLE_GOODS_PANEL = "vehicle-goods-panel";
export const DRIVER_SALES_PANEL = "driver-sales-panel";
